import React from 'react';

const About = ({ data }) => {
  const { stats, education } = data;

  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-16 h-0.5 bg-gradient-to-r from-transparent to-blue-500"></div>
            <span className="text-blue-400">Get To Know Me</span>
            <div className="w-16 h-0.5 bg-gradient-to-l from-transparent to-blue-500"></div>
          </div>
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">
            A passionate developer dedicated to building innovative solutions
          </p>
        </div>

        <div className="max-w-6xl mx-auto space-y-6">
          {/* Row 1: Journey and Metrics */}
          <div className="grid lg:grid-cols-2 gap-6">
            {/* My Journey Card */}
            <div className="card h-full">
              <div className="flex items-center gap-3 mb-3">
                <i className="fas fa-code text-blue-400 text-lg"></i>
                <h3 className="text-xl font-bold text-slate-800">My Journey</h3>
              </div>
              <div className="space-y-3 text-slate-600 text-sm leading-relaxed">
                <p>
                  I'm a developer focused on building agentic AI systems — designing RAG pipelines, multi-agent orchestration, and tool-calling workflows with LangGraph, Python, and FastAPI, alongside full-stack apps in Next.js and Node.js. I care about shipping secure, low-latency APIs and containerized, production-ready deployments.
                </p>
                <p>
                  A strong foundation in data structures and algorithms drives how I approach problems, and a hackathon-winning track record keeps me building fast under real constraints. As a student at BMS Institute of Technology & Management, I'm continually deepening my work across AI engineering and modern backend systems.
                </p>
              </div>
            </div>

            {/* Metrics */}
            <div className="grid grid-cols-2 gap-4 h-full">
              <div className="card py-5 px-5 flex flex-col justify-center">
                <div className="text-2xl font-bold text-blue-500 mb-1">{stats?.projectsCompleted}+</div>
                <div className="text-slate-800 font-medium text-sm">Projects</div>
                <div className="text-slate-500 text-xs">Completed</div>
              </div>
              <div className="card py-5 px-5 flex flex-col justify-center">
                <div className="text-2xl font-bold text-blue-500 mb-1">{stats?.technologiesMastered}+</div>
                <div className="text-slate-800 font-medium text-sm">Technologies</div>
                <div className="text-slate-500 text-xs">Mastered</div>
              </div>
              <div className="card py-5 px-5 flex flex-col justify-center">
                <div className="text-2xl font-bold text-blue-500 mb-1">{stats?.cgpa}</div>
                <div className="text-slate-800 font-medium text-sm">CGPA</div>
                <div className="text-slate-500 text-xs">Academic</div>
              </div>
              <div className="card py-5 px-5 flex flex-col justify-center">
                <div className="text-2xl font-bold text-blue-500 mb-1">{stats?.awardsWon}</div>
                <div className="text-slate-800 font-medium text-sm">Awards</div>
                <div className="text-slate-500 text-xs">Won</div>
              </div>
            </div>
          </div>

          {/* Row 2: Education across the full width, one card per qualification */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <i className="fas fa-graduation-cap text-blue-400 text-xl"></i>
              <h3 className="text-xl font-bold text-slate-800">Education</h3>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {education?.map((edu) => (
                <div key={edu.degree} className="card h-full flex flex-col">
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <h4 className="text-lg font-bold text-slate-800 leading-snug">{edu.degree}</h4>
                    {edu.current && (
                      <span className="px-2 py-1 bg-blue-500/20 text-blue-400 rounded text-xs whitespace-nowrap">
                        Current
                      </span>
                    )}
                  </div>
                  <p className="text-blue-400 text-sm mb-1">{edu.institution}</p>
                  <p className="text-slate-500 text-xs">{edu.field}</p>
                  <p className="text-slate-400 text-xs mt-1">{edu.period}</p>
                  {/* mt-auto keeps the grade on the baseline across all three cards */}
                  <p className="text-green-400 font-bold text-sm mt-auto pt-3">{edu.grade}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
